import defaultImage from '@/assets/images/default-company.jpg';
import { Button } from '@/components/Button';
import { Image } from '@/components/Image';
import { ImageCropper } from '@/components/ImageCropper';
import { Text } from '@/components/Text';
import { CreateCompanyForm } from '@/types/company';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CreateCompanyLogo = ({
  setFieldValue,
  values,
}: {
  setFieldValue: (field: string, value: unknown) => void;
  values: CreateCompanyForm;
}) => {
  const { t } = useTranslation();
  const [imageSrcForCrop, setImageSrcForCrop] = useState('');
  const [imageCropperIsOpen, setImageCropperIsOpen] = useState(false);
  const [logoPreview, setLogoPreview] = useState('');

  const handleUpdateLogo = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.click();
    input.onchange = async () => {
      const file = input.files?.[0];
      if (file) {
        setImageSrcForCrop(URL.createObjectURL(file));
        setImageCropperIsOpen(true);
      }
    };
  };

  const handleCropComplete = (croppedImage: File) => {
    setLogoPreview(URL.createObjectURL(croppedImage));
    const reader = new FileReader();
    reader.onload = () => {
      setFieldValue('logo', reader.result);
    };
    reader.readAsDataURL(croppedImage);
  };

  return (
    <div className="w-full">
      <Text className="text-center font-medium text-sky-800 md:text-left">
        {t('createCompany:logo.title')}
      </Text>
      <div className="mt-4 flex flex-col items-center sm:flex-row">
        <div className="relative mb-6 sm:mb-0">
          <Image
            className="size-24 rounded-full border-2 border-sky-100 object-cover shadow-sm"
            src={logoPreview}
            defaultImage={defaultImage}
            refreshKey={Date.now()}
            alt="Logo"
          />
        </div>
        <div className="flex w-full flex-col space-y-3 sm:ml-8 sm:w-auto sm:flex-row sm:space-x-3 sm:space-y-0">
          <Button onClick={handleUpdateLogo}>
            {!values.logo
              ? t('createCompany:logo.add')
              : t('createCompany:logo.update')}
          </Button>
          {values.logo && (
            <Button
              className="bg-danger"
              onClick={() => {
                setFieldValue('logo', null);
                setLogoPreview('');
              }}
            >
              {t('createCompany:logo.remove')}
            </Button>
          )}
        </div>
      </div>
      {imageCropperIsOpen && (
        <ImageCropper
          cropShape="round"
          showGrid={false}
          ratio={1}
          imageSrc={imageSrcForCrop}
          isOpen={imageCropperIsOpen}
          onClose={() => setImageCropperIsOpen(false)}
          onCropIsComplete={handleCropComplete}
        />
      )}
    </div>
  );
};
